import * as tracking from '../util/tracking';

function getResults(query) {
  return [
    { title: query, section: 'women' },
    { title: query, section: 'men' },
    { title: query, section: 'kids' },
    { title: query, section: 'home' },
    { title: query, section: 'beauty-care' },
  ];
}

export const fallbackQueryPerSectionSearchPlugin = {
  getSources({ state, query }) {
    return [
      {
        sourceId: 'fallbackQueryPerSectionSearchPlugin',
        async getItems() {
          // Don't show anything with no query
          if (!query) {
            return [];
          }

          // See if there are any other results
          const numberOfItems = state.collections.reduce((count, c) => {
            if (
              c.source.sourceId !== 'fallbackQueryPerSectionSearchPlugin' &&
              c.source.sourceId !== 'sectionHintSearchPlugin'
            ) {
              count += c.items.length;
            }
            return count;
          }, 0);

          // Don't show when there are more than 3 other results
          if (numberOfItems > 3) {
            return [];
          }

          if (window.cece.searchSection) {
            return getResults(query).filter(
              r => r.section === window.cece.searchSection
            );
          }
          return getResults(query);
        },
        templates: {
          item({ item, createElement }) {
            let url = `/catalog/search/?section=${
              item.section
            }&query=${encodeURIComponent(query)}`;
            return createElement(
              'a',
              {
                class: 'catalog-search-item',
                href: url,
                onClick(event) {
                  event.preventDefault();
                  tracking.trackEvent('CatalogSearch', 'ManualSearch', query);
                  setTimeout(function () {
                    window.location.href = url;
                  }, 50);
                },
              },
              // Search icon
              createElement('span', {
                class: 'icon',
                dangerouslySetInnerHTML: {
                  __html: `<svg class="cece-icon icon-search" height="18" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="7.19" cy="6.69" r="5.79" stroke="#000"/><path d="m11.6 11.09 5.03 5.03" stroke="#000" stroke-width="1.25"/></svg>`,
                },
              }),
              // Content
              createElement(
                'span',
                {
                  class: 'content',
                },
                item.title,
                createElement(
                  'span',
                  {
                    class: 'dimmed',
                  },
                  ` - in ${item.section}`
                )
              )
            );
          },
        },
      },
    ];
  },
};
